






import { Component, Vue } from 'vue-property-decorator';
import { getUrlParam, isTikTok } from '@/utils/common';

@Component({
  name: 'FaceIdentification'
})

export default class FaceIdentification extends Vue {
  created() {
    if (!isTikTok()) {
      return;
    }

    const orderStr = getUrlParam('order_str');
    console.log('orderStr1', orderStr);

    // @ts-ignore
    if (orderStr && ap) {
      // @ts-ignore
      ap.tradePay({
        orderStr: orderStr,
      }, function (res: never) {
        console.log('h5', res);
      });
    }
  }
}
